import { render, staticRenderFns } from "./onlinePageSetting.vue?vue&type=template&id=aa896b1c&scoped=true&"
import script from "./onlinePageSetting.vue?vue&type=script&lang=js&"
export * from "./onlinePageSetting.vue?vue&type=script&lang=js&"
import style0 from "./onlinePageSetting.vue?vue&type=style&index=0&id=aa896b1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa896b1c",
  null
  
)

export default component.exports